import React, { useEffect, useState } from 'react'
import '../../ApplicationsDashboard/ApplicationsDashboard.css';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../../components/Sidebar/Sidebar';
import SeedsLogo from "../../../assets/images/SeedsLogo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSearch,
    faBell,
    faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import UserProfileDropdown from '../../../components/UserProfile/UserProfile';
import './Supplier.css'
import { useDispatch, useSelector } from 'react-redux';
import { getSupplierReport } from '../../../redux/ReportsReducer/action';
import DatePicker from 'react-datepicker';
import { downloadReport, downloadReportByDateRange, resetFilters } from '../../../utils/reportUtils';
import DownloadReport from '../DownloadReport';
import { SUPPLIER_KYC_STATUS, SUPPLIER_TYPES } from '../../../utils/mappings';
import FilterModal from '../FilterModal/FilterModal';
import FunnelIconSvg from '../../../components/SVG/FunnelIconSvg';
import { isAuthorised } from '../../../utils/common';
import { REPORTS_COMPONENTS } from '../../../config/reports';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import { getAuthToken } from "../../../utils/auth";

const Supplier = () => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    const { supplierReport, pagination, officerProfile } = useSelector((store) => {
        return {
            supplierReport: store.ReportsReducer.supplierReport.data,
            pagination: store.ReportsReducer.supplierReport.pagination,
            officerProfile: store.UserReducer.officerProfile
        }
    }, []);

    const dispatch = useDispatch();
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    const storedFilters = JSON.parse(sessionStorage.getItem('trancheFilters')) || {};

    const [supplierFilters, setSupplierFilters] = useState({
        supplier_name: storedFilters?.supplier_name || "",
        supplier_id: storedFilters?.supplier_id || "",
        supplier_type: storedFilters?.supplier_type || "",
        supplier_status: storedFilters?.supplier_status || "",
        supplier_gst: storedFilters?.supplier_gst || "",
        supplier_email: storedFilters?.supplier_email || "",
        supplier_mobile_number: storedFilters?.supplier_mobile_number || "",
        branch: storedFilters?.branch || "",
        from_date: storedFilters?.from_date || "",
        to_date: storedFilters?.to_date || "",
        global_search: storedFilters?.global_search || "",
        sector: storedFilters?.sector || "",
        sub_sector: storedFilters?.sub_sector || ""
    });

    const navigate = useNavigate();

    const leads = [];

    const [currentPage, setCurrentPage] = useState(parseInt(sessionStorage.getItem('reportsCurrentPage')) || 1);
    const [limit, setLimit] = useState(parseInt(sessionStorage.getItem('reportsLimit')) || 10);
    const totalCount = parseInt(sessionStorage.getItem('reportsTotalCount')) || 0;
    const totalPages = Math.ceil(totalCount / limit);

    const [dateRange, setDateRange] = useState([
        supplierFilters?.from_date ? new Date(supplierFilters.from_date) : null,
        supplierFilters?.to_date ? new Date(supplierFilters.to_date) : null,
    ]);

    const [startDate, endDate] = dateRange;

    useEffect(() => {
        dispatch(getSupplierReport(currentPage, limit, supplierFilters, null));

        sessionStorage.setItem('reportsCurrentPage', currentPage);
        sessionStorage.setItem('reportsLimit', limit);
        sessionStorage.setItem('supplierFilters', JSON.stringify(supplierFilters));
        // }, [dispatch, limit, currentPage, supplierFilters]);
    }, [dispatch, limit, currentPage]);

    useEffect(() => {
        return () => {
            sessionStorage.removeItem("supplierFilters");
            sessionStorage.removeItem("reportsCurrentPage");
            sessionStorage.removeItem("reportsLimit");
            sessionStorage.removeItem("reportsTotalPages");
            sessionStorage.removeItem("reportsTotalCount");
        };
    }, []);

    const handlePageChange = (newPage) => {
        // Ensure we're working with 1-based pagination
        const pageToSet = Math.max(1, Math.min(newPage, totalPages));
        setCurrentPage(pageToSet);
        sessionStorage.setItem('reportsCurrentPage', pageToSet.toString());
    };

    const formatDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleDateRangeChange = (update) => {
        setDateRange(update);

        const [start, end] = update;

        const updatedFilters = {
            ...supplierFilters,
            from_date: formatDate(start),
            to_date: formatDate(end),
        };

        setSupplierFilters(updatedFilters);
        sessionStorage.setItem("supplierFilters", JSON.stringify(updatedFilters));
    };

    const handleFilterChange = (e) => {
        let { name, value } = e.target;

        if (typeof value === 'string') {
            value = value.replace(/[\t\n\r]+/g, '').replace(/^\s+/, '');
        }

        let updatedFilters = {
            ...supplierFilters,
            [name]: value
        };

        setSupplierFilters(updatedFilters);
        sessionStorage.setItem("supplierFilters", JSON.stringify(updatedFilters));
    }

    useEffect(() => {
        sessionStorage.setItem('reportsCurrentPage', currentPage);
        sessionStorage.setItem('reportsLimit', limit);
    }, [limit, currentPage]);

    return (
        <>
            <div className="reportsDashboardContainer">
                <div className="reportsDashboard">
                    <Sidebar />

                    <div className="dashboardMainContent">
                        <div className="contentHeader">
                            <div className="userLogo">
                                <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                            </div>
                            <div className="headerRightPanel">
                                {/* <div className="headerSearchBar">
                                <input type="text" placeholder="Search" />
                                <FontAwesomeIcon icon={faSearch} />
                            </div>
                            <div className="headerNotifications">
                                <FontAwesomeIcon icon={faBell} />
                                <span className="notificationBadge">9+</span>
                            </div>
                            <div className="headerHelp">
                                <FontAwesomeIcon icon={faQuestionCircle} />
                            </div> */}
                                <UserProfileDropdown />
                            </div>
                        </div>

                        <div className="pageContentWrapper">
                            <div className="pageHeaderSection">
                                <Breadcrumb items={[
                                    { label: 'Admin' },
                                    { label: 'Reports', onClick: () => navigate('/reports') },
                                    { label: 'Supplier' }
                                ]} />

                                <div className="pageActions">
                                    <h2>Supplier</h2>
                                </div>
                            </div>

                            <div className="searchControlSection">
    <div className="searchGroup">
        {isAuthorised(
            officerProfile,
            REPORTS_COMPONENTS['supplier_search']
        ) && <div className="tableSearchBar">
                <input
                    // type="text" 
                    type="search"
                    placeholder="Search"
                    name="global_search"
                    value={supplierFilters?.global_search}
                    onChange={handleFilterChange}
                    onInput={(e) => {
                        if (e.target.value === "") {
                            let updatedFilters = {
                                ...supplierFilters,
                                global_search: e.target.value
                            }

                            setSupplierFilters(updatedFilters)

                            dispatch(getSupplierReport(1, limit, updatedFilters));
                            handlePageChange(1);
                        }
                    }}
                />
                {/* <FontAwesomeIcon icon={faSearch} /> */}
            </div>}
        <div className="searchActionButtons">
            {isAuthorised(
                officerProfile,
                REPORTS_COMPONENTS['supplier_search']
            ) && <button
                className="searchButton iconOnly"
                title="Search"
                onClick={() => {
                    dispatch(getSupplierReport(1, limit, supplierFilters, null));
                }}
            >
                <FontAwesomeIcon icon={faSearch} />
            </button>}
            {isAuthorised(
                officerProfile,
                REPORTS_COMPONENTS['supplier_download']
            ) && <button
                className="downloadButton"
                // onClick={() => downloadReportByDateRange("supplier", supplierFilters?.from_date, supplierFilters?.to_date)}
                // onClick={() => setShowDownloadModal(true)}
                onClick={() => {
                    downloadReport("supplier", supplierFilters, setIsDownloading);
                }}
                disabled={isDownloading}
            >
                {isDownloading ? (
                    <>
                        <span className="buttonSpinner"></span>
                        Downloading...
                    </>
                ) : (
                    <>
                        Download
                    </>
                )}
            </button>}
            {isAuthorised(
                officerProfile,
                REPORTS_COMPONENTS['supplier_filters']
            ) && <button
                className="filterButton"
                onClick={() => setShowFilterModal(true)}
            >
                <FunnelIconSvg fillColor={"black"} />
            </button>}
        </div>
    </div>
</div>

                            {
                                showFilterModal && (
                                    <FilterModal
                                        reportTitle={"supplier"}
                                        filters={supplierFilters}
                                        setFilters={setSupplierFilters}
                                        resetFilters={() => {
                                            let resettedFilters = resetFilters(supplierFilters);

                                            setSupplierFilters(resettedFilters);
                                            dispatch(getSupplierReport(1, limit, resettedFilters, null));
                                            handlePageChange(1);
                                            setShowFilterModal(false);
                                            sessionStorage.setItem("supplierFilters", JSON.stringify(resettedFilters));
                                            return resettedFilters;
                                        }}
                                        handleApplyFilters={(finalFilters) => {
                                            handlePageChange(1);
                                            dispatch(getSupplierReport(1, limit, finalFilters, null));
                                            setShowFilterModal(false);
                                        }}
                                        onClose={() => {
                                            setShowFilterModal(false)
                                        }}
                                    />
                                )
                            }

                            <div className="tableCard">
                                <main className="">
                                    <div className="reportsTableContainer">
                                        <table className="applications-table" style={{ overflowX: "auto" }}>
                                            <thead>
                                                <tr>
                                                    <th>Supplier ID</th>
                                                    <th>Branch</th>
                                                    <th>Supplier Name</th>
                                                    <th>Supplier GST</th>
                                                    <th>Supplier Address</th>
                                                    <th>Supplier Email</th>
                                                    <th>Supplier Mobile Number</th>
                                                    <th>Supplier Sector</th>
                                                    <th>Supplier Sub Sector</th>
                                                    <th>Supplier Requested Date</th>
                                                    <th>Supplier Verification Date</th>
                                                    <th>Supplier Status</th>
                                                    <th>Supplier Type</th>
                                                    <th>Linked Customers</th>
                                                    <th>Linked Bank Account Count</th>
                                                    <th>Linked Paid Bills Count</th>
                                                    <th>Linked Paid Bills A/M (Cum/Current)</th>
                                                    <th>Linked Reg/OD Client</th>
                                                </tr>
                                                {/* <tr className="filter-row">
                                        <td>
                                            <input
                                                type="text"
                                                name="supplier_id"
                                                value={supplierFilters?.supplier_id || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="branch"
                                                value={supplierFilters?.branch || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="supplier_name"
                                                value={supplierFilters?.supplier_name || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="supplier_gst"
                                                value={supplierFilters?.supplier_gst || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                            <DatePicker
                                                selectsRange
                                                startDate={startDate}
                                                endDate={endDate}
                                                onChange={handleDateRangeChange}
                                                isClearable
                                                placeholderText="Select date range"
                                                className="form-control form-control-sm date-picker-filter"
                                            />
                                        </td>
                                        <td>
                                            <DatePicker
                                                selectsRange
                                                startDate={startDate}
                                                endDate={endDate}
                                                onChange={handleDateRangeChange}
                                                isClearable
                                                placeholderText="Select date range"
                                                className="form-control form-control-sm date-picker-filter"
                                            />
                                        </td>
                                        <td>
                                            <select 
                                                name="supplier_status"
                                                className="column-filter status-filter"
                                                value={supplierFilters?.supplier_status || ""}
                                                onChange={handleFilterChange}
                                            >
                                                <option value="">All Status</option>
                                                {
                                                    Object.entries(SUPPLIER_KYC_STATUS).map(([key, label]) => (
                                                        <option key={key} value={label}>
                                                            {label}
                                                        </option>
                                                    ))
                                                }
                                            </select>
                                        </td>
                                        <td>
                                            <select 
                                                name="supplier_type"
                                                className="column-filter status-filter"
                                                value={supplierFilters?.supplier_type || ""}
                                                onChange={handleFilterChange}
                                            >
                                                <option value="">All Types</option>
                                                {
                                                    Object.entries(SUPPLIER_TYPES).map(([key, label]) => (
                                                        <option key={key} value={label}>
                                                            {label}
                                                        </option>
                                                    ))
                                                }
                                            </select>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr> */}
                                            </thead>
                                            <tbody>
                                                {
                                                    supplierReport?.length === 0 ?
                                                        <tr>
                                                            <td colSpan={18} className="no-data-cell">
                                                                No records found
                                                            </td>
                                                        </tr> :
                                                        supplierReport?.map((supplier, index) => (
                                                            <tr key={index}>
                                                                <td>{supplier?.supplier_id}</td>
                                                                <td>{supplier?.branch}</td>
                                                                <td>{supplier?.supplier_name}</td>
                                                                <td>{supplier?.supplier_gst}</td>
                                                                <td>{supplier?.supplier_address}</td>
                                                                <td>{supplier?.supplier_email}</td>
                                                                <td>{supplier?.supplier_mobile_number}</td>
                                                                <td>{supplier?.supplier_sector}</td>
                                                                <td>{supplier?.supplier_sub_sector}</td>
                                                                <td>{supplier?.supplier_requested_at?.split('T')?.[0]}</td>
                                                                <td>{supplier?.supplier_verified_at?.split('T')?.[0]}</td>
                                                                <td>{supplier?.supplier_status}</td>
                                                                <td>{supplier?.supplier_type}</td>
                                                                <td>{supplier?.linked_customers}</td>
                                                                <td>{supplier?.linked_bank_account}</td>
                                                                <td>{supplier?.linked_paid_bills_count}</td>
                                                                <td>{supplier?.linked_paid_cumulative_principle}</td>
                                                                <td>{supplier?.od_status}</td>
                                                            </tr>
                                                        ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    {supplierReport?.length > 0 && <div className="paginationControls">
                                        <CustomPagination
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>}
                                </main>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                showDownloadModal && (
                    <DownloadReport
                        isOpen={showDownloadModal}
                        onClose={() => setShowDownloadModal(false)}
                        reportTitle={"supplier"}
                    />
                )
            }
        </>
    )
}

export default Supplier